// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@steiner/XDL/Utilities/mergeWithCss";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: StyledBoxStyles;
    [key: string]: any;
}

export interface StyledBoxStyles {
    container?: InjectableCss;
}

export const styledBoxStyle = css`
    padding: 12px;
    background: ${getColor("common.white")};
    border: 1px solid ${getColor("common.border")};
`;

const styledBoxStyles: StyledBoxStyles = {
    container: {
        css: css`
            ${styledBoxStyle}
        `,
    },
};

const StyledBox: React.FC<OwnProps> = ({ children, extendedStyles, ...otherProps }) => {
    const [styles] = useState(() => mergeWithCss(styledBoxStyles, extendedStyles));

    if (!React.Children.count(children)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector="styled-box" {...otherProps}>
            {children}
        </StyledWrapper>
    );
};

export default StyledBox;
